// export const SET_DASHBOARD_DATA = "SET_DASHBOARD_DATA";
// export const SET_DASHBOARD_DATA_FILTER = "SET_DASHBOARD_DATA_FILTER";
export const SET_RIDER_CURRENT_ORDER_DATA = "SET_RIDER_CURRENT_ORDER_DATA";
export const SET_RIDER_CURRENT_ORDER_DATA_PAGINATION_DATA = "SET_RIDER_CURRENT_ORDER_DATA_PAGINATION_DATA";
export const SET_RIDER_CURRENT_ORDER_STOREID_DATA = "SET_RIDER_CURRENT_ORDER_STOREID_DATA";
export const SET_METRICS_DASHBOARD_DATA = "SET_METRICS_DASHBOARD_DATA";
export const SET_METRICS_DASHBOARD_FILTER = "SET_METRICS_DASHBOARD_FILTER";
export const SET_METRICS_DASHBOARD_LOADER = "SET_METRICS_DASHBOARD_LOADER";
export const SET_SHIFTS_LIST = "SET_SHIFTS_LIST";
export const SET_SHIFTS_MART_LIST = "SET_SHIFTS_MART_LIST";
export const SET_PAGINATION_SHIFTS_LIST = "SET_PAGINATION_SHIFTS_LIST";
export const SET_SHIFTS_LOADING = "SET_SHIFTS_LOADING";
export const SET_MART_FILTER = "SET_MART_FILTER";
export const SET_SHIFTS_FILTER = "SET_SHIFTS_FILTER";
export const RESET_DASHBOARD_REDUCER = "RESET_DASHBOARD_REDUCER";
